import { SelectOption } from 'modules/queryBuilder/contexts';
import { UNSUBSCRIBED_MESSAGE_TYPE_REPLACEMENT_FEATURE_FLAG } from 'modules/queryBuilder/featureFlags';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { UNSUBSCRIBED_MESSAGE_TYPES } from 'utils/fieldConstants';

export const useFilterNonUnsubscribedMessageTypesFromOptions = () => {
  const isFeatureFlagged = useFeatureFlag(UNSUBSCRIBED_MESSAGE_TYPE_REPLACEMENT_FEATURE_FLAG);
  return (options: SelectOption<string>[]) =>
    options.filter((option) =>
      isFeatureFlagged ? option.value !== UNSUBSCRIBED_MESSAGE_TYPES : option,
    );
};
